import { get } from 'lodash/fp';
import React from 'react';
import { Link } from 'react-router-dom';
import { getSimulationTunnel } from 'utils/simulationTunnel';
import { useSession } from '../../sessions';

const Logo = () => {
    const session = useSession();
    const simulationTunnel = getSimulationTunnel();

    return session.settings && (
        simulationTunnel ? (
            <span title={get('entity.name', session)}>
                <img src={session.settings.logo} alt={get('entity.name', session)} />
            </span>
        ) : (
            <Link title="Retourner à la liste" to={session.signatureOnly ? '/signatures' : '/'}>
                <img src={session.settings.logo} alt={get('entity.name', session)} />
            </Link>
        )
    );
};

export default Logo;
